import React from 'react';

import {map, includes} from 'lodash-es';
import PropTypes from 'prop-types';

import {onSuggestionKeyDown} from 'static/three-oh/src/components/GlobalLayout/GlobalNav/GlobalNavSearch/helpers';
import {
  GlobalNavSearchSuggestionsSection,
  GlobalNavSearchSuggestion,
  SectionHeader,
} from 'static/three-oh/src/components/GlobalLayout/GlobalNav/GlobalNavSearch/JeevesSearchSuggestions/SuggestionParts/SuggestionParts';
import {toSnakeCase} from 'static/three-oh/utils/stringUtils';

import styles from './styles.scss';

class RecentSearches extends React.Component {
  static propTypes = {
    onQueryTermSubmission: PropTypes.func.isRequired,
    trackUserEvent: PropTypes.func.isRequired,
    userProperties: PropTypes.object.isRequired,
    isGlobalNavSearch: PropTypes.bool.isRequired,
    onSuggestionDismiss: PropTypes.func,
    onSuggestionTab: PropTypes.func,
  };

  static defaultProps = {
    isGlobalNavSearch: false,
  };

  /**
   * Track the submission of a recent search terms.
   * @param {string} recentTerm - The selected term.
   * @param {boolean} click - A boolean value indicating whether the event was a click event
   *   (vs a keydown event).
   */
  onRecentTermSubmit = (recentTerm, click = true) => {
    const {onQueryTermSubmission, trackUserEvent} = this.props;
    const eventProperties = {
      term: recentTerm,
      user_invoked_search: true
    };
    trackUserEvent('recent_search_submit', eventProperties, click);
    onQueryTermSubmission(recentTerm);
  };

  /**
   * Track keydown events for recent search terms.
   * @param {Event} event - The keydown event.
   * @param {string} recentTerm - The selected term.
   */
  onRecentTermKeyDownForGlobalNavSearch = (event, recentTerm) => {
    const params = {
      event: event,
      onSuggestionSubmit: () => this.onRecentTermSubmit(recentTerm, false),
      onSuggestionDismiss: this.props.onSuggestionDismiss,
      onSuggestionTab: this.props.onSuggestionTab,
    };
    onSuggestionKeyDown(params);
  };

  /**
   * Track keydown events for recent search terms.
   * @param {Event} event - The keydown event.
   * @param {string} recentTerm - The selected term.
   */
  onRecentTermKeyDown = (event, recentTerm) => {
    if (includes(['Enter', ' '], event.key)) {
      this.onRecentTermSubmit(recentTerm, false);
    }
  };

  render() {
    const {isAuthenticated, isStudent} = this.props.userProperties;
    const recentSearchTermsString = sessionStorage.getItem('recentSearchTerms');
    const noRecentSearchesExist = !recentSearchTermsString || !recentSearchTermsString.length;

    if (!isAuthenticated || isStudent || noRecentSearchesExist) {
      return null;
    }

    const recentSearchTermsArray = recentSearchTermsString.split(',').reverse();
    const recentTermRows = map(recentSearchTermsArray, (term) => {
      return (
        this.props.isGlobalNavSearch ?
            (
              <GlobalNavSearchSuggestion
                onClick={() => this.onRecentTermSubmit(term)}
                onKeyDown={(event) => { this.onRecentTermKeyDownForGlobalNavSearch(event, term); }}
                suggestionText={term}
                isStandard={false}
              />
            ) :
            (
              <div
                className={styles.recentTerm}
                key={term}
                data-qa-selector={`${toSnakeCase(term)}_recent_search`}
              >
                <p
                  onClick={() => this.onRecentTermSubmit(term)}
                  onKeyDown={(event) => this.onRecentTermKeyDown(event, term)}
                  tabIndex="0"
                >
                  {term}
                </p>
              </div>
            )
      );
    });

    return (
      this.props.isGlobalNavSearch ?
          (
            <GlobalNavSearchSuggestionsSection
              header={<SectionHeader headerTitle="Recent"/>}
              listItems={recentTermRows}
              ariaLabel="Recent Searches"
              dataQaSelector="recent_searches"
            />
          ) :
          (
            <div className={styles.recentTermList}>
              <div
                className={styles.sectionTitle}
                data-qa-selectors="recent_searches_title"
              >
                <h4>Recent Searches</h4>
              </div>
              {recentTermRows}
            </div>
          )
    );
  }
}

export default RecentSearches;
